<template>
  <q-td :props="props" :key="colKey">
    {{ $t(`verbandbuch.${props.row.eintragType}`) }}
  </q-td>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    props: {
      type: Object,
      required: true,
    },
    colKey: {
      type: String,
      required: true,
    },
  },
});
</script>
